import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';
import { Colors } from 'src/shared/components/styles/colors';
import ConsoleHelper from 'src/shared/functions/consoleHelper';

type EmbededCodePreviewModalProps = {
  modalOpen: boolean;
  onClose: () => void;
  embeddedCode: string;
};

export const EmbededCodePreviewModal = (props: EmbededCodePreviewModalProps) => {
  const { modalOpen, onClose, embeddedCode } = props;
  const { t } = useTranslation();

  const onCloseHandler = () => {
    onClose();
  };

  return (
    <>
      <GenericDialog
        open={modalOpen}
        onClose={onCloseHandler}
        onSave={() => ConsoleHelper.log('save')}
        dialogTitle={t('fundraiser:preview')}
        padding={0}
        dialogContent={
          <Box sx={{ backgroundColor: Colors.Form.DisabledInput }}>
            <iframe srcDoc={embeddedCode} style={{ width: '100%', height: '80vh', border: 'none' }} title={t('fundraiser:preview')} />
          </Box>
        }
        dialogActions={
          <Button variant='outlined' color='primary' disableElevation onClick={onClose}>
            {t('common:button.close')}
          </Button>
        }
      />
    </>
  );
};
